import { usePolicy } from '../../policies/queries/usePolicy';
import {
  ChangeConfirmationPolicyData,
  getChangeConfirmationPolicyData,
} from '../../policies/components/change-confirmation/types';
import { EnvironmentId } from '../types';

import { useEnvironment } from './useEnvironment';

export function useChangeConfirmationPolicy(
  environmentId: EnvironmentId | undefined
): ChangeConfirmationPolicyData | null {
  const { data: environment } = useEnvironment(environmentId);
  const policyId = environment?.Policies?.changeConfirmationPolicy?.policyID;

  const { data: policy } = usePolicy(policyId ?? 0, {
    enabled: !!policyId,
    staleTime: 60 * 1000,
  });

  return getChangeConfirmationPolicyData(policy?.Data);
}
